export const ErrorTypes = {
  WrongEmailPassword: {
    value: "email-password-wrong",
    title: "로그인 실패",
    description: "아이디 또는 비밀번호가 올바르지 않습니다.",
    confirmBtnName: "확인",
  },
  NoExistEmail: {
    value: "no-exist-email",
    title: "로그인 실패",
    description: "존재하지 않는 사용자 입니다. 회원가입을 진행해 주세요.",
    confirmBtnName: "확인",
  },
  ValidEmail: {
    value: "valid-email",
    title: "이메일 또는 비밀번호를 확인하세요.",
    description:
      "이메일 또는 비밀번호가 권장사항에 맞지 않습니다. 올바른 이메일 또는 비밀번호 형식인지 확인해주세요.",
    confirmBtnName: "확인",
  },
  AlreadyExistEmail: {
    value: "email-already-exist",
    title: "이미 존재하는 이메일입니다.",
    description: "다른 이메일을 이용하시거나 로그인을 진행해 주세요.",
    confirmBtnName: "확인",
  },
  WeakPassword: {
    value: "weak-password",
    title: "비밀번호 설정이 약합니다.",
    description: "다른 비밀번호를 설정해주세요.",
    confirmBtnName: "확인",
  },
  NoAccessRights: {
    value: "no-access-rights",
    title: "접근 권한이 필요합니다.",
    description: "로그인 또는 권한이 필요합니다.",
    confirmBtnName: "확인",
  },
};

export default ErrorTypes;
